import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import { CommonService } from 'app/_services/common.service';
import { OrganisationsService } from 'app/_services/organisations.service';
@Component({
  selector: 'app-addedit-queue-template',
  templateUrl: './addedit-queue-template.component.html',
  styleUrls: ['./addedit-queue-template.component.scss']
})
export class AddeditQueueTemplateComponent implements OnInit {

  organizationType:any
  orgtypeselectedValue:any
  errorMessage: string;
  QueueTempalteForm:FormGroup; 
  productLoading:Boolean=false
  queueTemplateSubmitted = false;
  utoken:string = localStorage.getItem("utoken");
  usermasterid:any = localStorage.getItem("user_master_id");
  queueTemplateId:any = "";
  imageValue:any = {
    queueTemplateImage:"", 
   
    onchangeFilName:"",
    queueExistingImage:""
  }

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonService:CommonService,
    private router: Router,
    private snackbar:MatSnackBar,
    private orgservice: OrganisationsService,
  ){
    this.activatedRoute.params.subscribe((params) => {
      if(params.queue_template_id != "" && params.queue_template_id != undefined){
        this.queueTemplateId = params.queue_template_id;


        this.getQueueTemplateDetails();
      }
    })
  }

  ngOnInit() {
    this.QueueTempalteForm = this.formBuilder.group({
      queueTemplateName:['',[Validators.required]],
      queueTemplateImage:[''],
      servicetype:['',[Validators.required]],
      queueTemplateStatus:['Active',[Validators.required]],
    }); 
    this.getOrganizationType()
  }

  getQueueTemplateDetails(){

  

    if(this.queueTemplateId != ""){
      this.commonService.getQueueTemplates(this.queueTemplateId).subscribe((response)=>{
        if(response.status_code == "200"){
          this.imageValue.queueExistingImage = response.Data[0].queue_image;
          this.imageValue.queueTemplateImage = response.Data[0].image_path;
          this.orgtypeselectedValue = response.Data[0].service_type;

console.log("response",response)


console.log("orgtypeselectedValue",this.orgtypeselectedValue)

          this.QueueTempalteForm.controls['queueTemplateName'].setValue(response.Data[0].queue_name);
          this.QueueTempalteForm.controls['queueTemplateStatus'].setValue(response.Data[0].status);
        }
      })
    }
  }

  OnSubmit(){

   

    this.queueTemplateSubmitted = true;
    if(this.QueueTempalteForm.invalid){
      return;
    }
    this.productLoading=true
    this.commonService.addEditQueueTemplate(this.QueueTempalteForm,this.queueTemplateId,this.imageValue).subscribe((response)=>{
      if(response.status_code == 200){
        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-green']
        });

        this.router.navigate(['/queue-template']);
        /*
        setTimeout(() => {
            this.router.navigate(['/queue-template']);
        }, 4000);
*/
        this.productLoading=false

      }else{
        this.productLoading=false
        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      }
    })
  }


  getOrganizationType(){
    this.orgservice.getOrganizationTypeActive().subscribe((response)=>{
        this.organizationType = response.Data
    })
}

  onFileChange(event:any){

    if((event.target.files[0].type=="image/jpeg")||(event.target.files[0].type=="image/jpg")||(event.target.files[0].type=="image/png"))
    {
    this.imageValue.onchangeFilName = event.target.files[0];
    }
    else 
    {
      this.snackbar.open("Invalid file type selected. Please select *.png, *.jpg, *.jpeg files.",'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });
    }
  
  }
}



// WEBPACK FOOTER //
// ./src/app/component/addedit-queue-template/addedit-queue-template.component.ts